import { useEffect, useState } from "react";
import { Check, Mail, Users } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import WhatsAppLink from "@/components/admin/WhatsAppLink";

const MSG = (name) => `Hello ${name || ""}, good news from Anou Appran: a Holiday Pack spot is now available for your child! Book it on ${window.location.origin}/pricing — Bonne nouvelle : une place Holiday Pack est disponible, réservez-la sur ${window.location.origin}/pricing`;

export default function HolidayWaitlist() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/holiday/waitlist").then(({ data }) => setList(data.waitlist)).catch(() => {});
  useEffect(() => { load(); }, []);
  const done = async (id) => { await api.post(`/admin/holiday/waitlist/${id}/contacted`); toast.success("Marked as contacted"); load(); };
  if (!list) return null;
  return (
    <div className="bg-slate-800 rounded-2xl border-2 border-orange-400/30 p-4 mb-4" data-testid="admin-holiday-waitlist">
      <p className="font-bold flex items-center gap-2"><Users size={16} className="text-orange-300" /> Holiday Pack waiting list
        <span className="text-xs text-slate-400 font-normal">{list.filter((w) => !w.contacted_at).length} waiting · {list.length} total</span></p>
      {list.length === 0 ? <p className="text-sm text-slate-400 mt-2">Nobody on the waiting list.</p> : (
        <div className="mt-3 space-y-2">
          {list.map((w) => (
            <div key={w.id} className={`flex flex-wrap items-center gap-2 text-sm rounded-xl px-3 py-2 ${w.contacted_at ? "bg-slate-900/40 text-slate-500" : "bg-slate-900"}`} data-testid={`waitlist-row-${w.id}`}>
              <span className="font-semibold">{w.parent_name}</span>
              <span className="text-slate-400">{w.children.join(", ")}</span>
              <span className="text-xs text-slate-500">joined {new Date(w.created_at).toLocaleDateString()}</span>
              <span className="ml-auto inline-flex flex-wrap items-center gap-1.5">
                <a href={`mailto:${w.parent_email}?subject=${encodeURIComponent("Anou Appran — a Holiday Pack spot is available")}&body=${encodeURIComponent(MSG(w.parent_name))}`}
                  className="inline-flex items-center gap-1 rounded-full bg-blue-500 text-white px-2.5 py-0.5 text-xs font-bold" data-testid={`waitlist-email-${w.id}`}><Mail size={12} /> {w.parent_email}</a>
                <WhatsAppLink number={w.parent_whatsapp} name={w.parent_name} consentAccount={w.parent_consent_account} consentMarketing={w.parent_consent_marketing}
                  message={MSG(w.parent_name)} messageLabel="Spot available" testId={`waitlist-whatsapp-${w.id}`} />
                {w.contacted_at ? <span className="text-xs text-green-400 font-bold" data-testid={`waitlist-contacted-${w.id}`}>Contacted</span> : (
                  <button onClick={() => done(w.id)} className="inline-flex items-center gap-1 rounded-full border border-green-400 text-green-300 px-2.5 py-0.5 text-xs font-bold" data-testid={`waitlist-mark-${w.id}`}><Check size={12} /> Mark contacted</button>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
